// extracted by mini-css-extract-plugin
module.exports = {"pricing":"_22017e","currency":"_835c88","subscript":"_0066d0","priceAndModel":"_26843e","iconsSection":"_0ca1ed","iconText":"_5c8b1d"};